<template>
  <div class="bespread-wrap module-layer3">
    <div class="screen-container">
      <div class="cnt">
        <img src="../../assets/img/layer3/bt.png" class="bt" />
        <div class="progress-bg">
          <div class="progress">
            <img
              src="../../assets/img/layer3/d-0.png"
              alt=""
              srcset=""
              class="progress-img-size"
              v-if="preview < 50000"
            />

            <div v-else>
              <img
                v-for="(value, fKey) in previewList"
                :key="fKey"
                :src="
                  require('../../assets/img/layer3/d-' + (fKey + 1) + '.png')
                "
                alt=""
                srcset=""
                class="progress-img-size"
                :class="[
                  'item' + (fKey + 1),
                  preview >= value &&
                  (fKey + 1 === previewList.length ||
                    preview < previewList[fKey + 1])
                    ? 'pimg-block'
                    : 'pimg-none'
                ]"
              />
            </div>
          </div>
        </div>
        <img src="../../assets/img/layer3/role.png" class="role" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {
      preview: 0,
      previewList: [50000, 100000, 200000, 300000, 500000] // 卡片
    };
  },
    created() {
      this.initData()
    },
  methods: {
     // info 接口获取数据
    initData() {
      const reqTime = Math.floor(new Date().getTime() / 1000);
      let url = window.location.search;
      let preview = "unknow";
      let previewParam =
        url.indexOf("preview") >= 0
          ? this.common.getUrlParam("preview")
          : this.common.getUrlParam("preview");
      preview = previewParam || "unknow";

      this.$axios({
        method: "post",
        url: "braveheart/info",
        data: {
          //get这里应为params
          //请求参数
          signature: this.common.makeSignature({}, reqTime),
          reqTime: reqTime,
          // preview: this.common.getUrlParam("preview") || 0, // 测试数据
          preview: preview
        },
        //withCredentials:true, //局部携带cookie
        headers: {} //如果需要添加请求头可在这写
      })
        .then(res => {
          if (res.data.code === 0) {
            this.preview = res.data.data.register;
          }
        })
        .catch(err => {
          //请求失败就会捕获报错信息
          //err.response可拿到服务器返回的报错数据
        });
    }
  }
};
</script>
<style lang="scss">
.module-layer3 {
  // pointer-events: none;
  background-image: url("../../assets/img/layer3/bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .pimg-block {
    display: block;
  }
  .pimg-none {
    display: none;
  }
  .screen-container {
    width: calc(100% - 250px);
    .cnt {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      gap: 1vw;
      .role {
        position: absolute;
        bottom: -4vw;
        right: -9.8vw;
        width: 952px;
        height: auto;
      }
      .bt {
        width: 1044px;
        height: auto;
      }
      .progress-bg {
        background-image: url("../../assets/img/layer3/progress-bg.png");
        background-size: 100% 100%;
        width: 1113px;
        height: 744px;
        position: relative;

        .progress {
          position: absolute;
          top: 4vw;
          left: 3vw;
          .progress-img-size {
            width: 801px;
            height: auto;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer3 {
   .cnt{
            // gap:3vw !important;
            .role {
              width: 1070px !important;
            }
   } 
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer3.vue